/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftEndMutationResponse, PostApiBarberShiftEnd400, PostApiBarberShiftEnd401, PostApiBarberShiftEnd403, PostApiBarberShiftEnd404, PostApiBarberShiftEnd500 } from "../entities/PostApiBarberShiftEnd";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberShiftEnd } from "../api/postApiBarberShiftEnd";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberShiftEndMutationKey = () => [{ url: '/api/barber/shift/end' }] as const

export type PostApiBarberShiftEndMutationKey = ReturnType<typeof postApiBarberShiftEndMutationKey>

export function postApiBarberShiftEndMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = postApiBarberShiftEndMutationKey()
        return mutationOptions<PostApiBarberShiftEndMutationResponse, ResponseErrorConfig<PostApiBarberShiftEnd400 | PostApiBarberShiftEnd401 | PostApiBarberShiftEnd403 | PostApiBarberShiftEnd404 | PostApiBarberShiftEnd500>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return postApiBarberShiftEnd(config)
          },
        })

}

/**
 * @description Мастер завершает рабочую смену
 * @summary Завершить смену
 * {@link /api/barber/shift/end}
 */
export function usePostApiBarberShiftEnd<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberShiftEndMutationResponse, ResponseErrorConfig<PostApiBarberShiftEnd400 | PostApiBarberShiftEnd401 | PostApiBarberShiftEnd403 | PostApiBarberShiftEnd404 | PostApiBarberShiftEnd500>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberShiftEndMutationKey()

          const baseOptions = postApiBarberShiftEndMutationOptions(config) as UseMutationOptions<PostApiBarberShiftEndMutationResponse, ResponseErrorConfig<PostApiBarberShiftEnd400 | PostApiBarberShiftEnd401 | PostApiBarberShiftEnd403 | PostApiBarberShiftEnd404 | PostApiBarberShiftEnd500>, void, TContext>
          

          return useMutation<PostApiBarberShiftEndMutationResponse, ResponseErrorConfig<PostApiBarberShiftEnd400 | PostApiBarberShiftEnd401 | PostApiBarberShiftEnd403 | PostApiBarberShiftEnd404 | PostApiBarberShiftEnd500>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberShiftEndMutationResponse, ResponseErrorConfig<PostApiBarberShiftEnd400 | PostApiBarberShiftEnd401 | PostApiBarberShiftEnd403 | PostApiBarberShiftEnd404 | PostApiBarberShiftEnd500>, void, TContext>
      
}